import axios from "axios";

const language = localStorage.getItem("language") || "en";

const NodeInstance = axios.create({
  baseURL: process.env.REACT_APP_NODE_BACKEND_URL,
  headers: {
    "Content-type": "application/json",
    "X-localization": language,
    Accept: "application/json",
  },
});

// Add a request interceptor
NodeInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("nodeToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

NodeInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (
      error?.response?.status == 401 &&
      error?.response?.data?.message == "Unauthenticated."
    ) {
      localStorage.removeItem("token");
      localStorage.removeItem("nodeToken");
      location.replace("/login");
      return Promise.reject(error);
    }
    return Promise.reject(error);
  }
);

export default NodeInstance;
